// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CiOaUzody9MsY2m9RJ0T{display:none}.Gpinsaj9VlKS8cp4u7x3>.Ksr2ScjSN1aRRMjmUFxb{color:#000}`, "",{"version":3,"sources":["webpack://./src/components/PaginationElementComponent/PaginationElementComponentStyles.module.scss"],"names":[],"mappings":"AAAA,sBACI,YAAA,CAIA,4CACI,UAAA","sourcesContent":[".hidden {\n    display: none;\n}\n\n.ltgt {\n    > .ignoreThis {\n        color: #000000;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export var hidden = `CiOaUzody9MsY2m9RJ0T`;
export var ltgt = `Gpinsaj9VlKS8cp4u7x3`;
export var ignoreThis = `Ksr2ScjSN1aRRMjmUFxb`;
export default ___CSS_LOADER_EXPORT___;
